export const statusAction = {
  'Waiting payment': ['View Details', 'Cancel Order'],
  'Pending': ['View Details', 'Request refund'],
  'Partial delivery': ['View Details'],
  'Shipped': ['View Details', 'Confirm Receipt'],
  'Complete': ['View Details'],
  'Cancel': ['View Details'],
  'Refunding': ['View Details'],
  'Refunded': ['View Details']
}

// Waiting payment（待付款）：View Details（查看详情），Cancel Order（取消订单）
// Pending(待发货)：View Details（查看详情），Request refund（申请退款）
// Partial delivery(部分发货)：View Details（查看详情）,
// Shipped(已发货)：View Details（查看详情）,Confirm Receipt(确认收货)
// Complete(已完成)：View Details（查看详情）
// Cancel(取消)：View Details（查看详情）
// Refunding（退款中）View Details（查看详情）
// Refunded（已退款）View Details（查看详情）
